import { CollaborationEnabledProvider } from "@/features/collaboration/providers";
import { Floating } from "@/shared";
import Tooltip from "@components/ui/tooltip";
import { cn } from "@lib/cn";
import { useAppDispatch } from "@store";
import { setDialogId } from "@store/global-slice";
import { IconMessagePlus } from "@tabler/icons-react";
import { useState } from "react";
import { Comments } from "./Comments";

export const CommentsWithTrigger = ({
  id,
  className,
  activeClassName,
  iconClassName,
  tooltip,
}: {
  id: string;
  className?: string;
  activeClassName?: string;
  iconClassName?: string;
  tooltip?: string;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const triggerContent = (
    <div
      id={`comments-trigger:${id}`}
      className={cn(className, isOpen && activeClassName)}
    >
      <IconMessagePlus
        stroke={1.5}
        className={cn("tw-size-4 !tw-fill-none", iconClassName)}
      />
    </div>
  );

  return (
    <CollaborationEnabledProvider
      fallback={
        <EnableActionTrigger id={`comments-trigger:${id}`} className={className || ""} />
      }
    >
      <div data-comment-action-trigger>
        <Floating
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          customOffset={10}
          isPortal
          overwriteIndex={20}
          disableAutoUpdate
          position="absolute"
          placement="bottom-start"
          trigger={
            tooltip ? (
              <Tooltip placement="bottom" open={isOpen ? false : undefined}>
                <Tooltip.Trigger>{triggerContent}</Tooltip.Trigger>
                <Tooltip.Content>
                  <Tooltip.Text>{tooltip}</Tooltip.Text>
                </Tooltip.Content>
              </Tooltip>
            ) : (
              triggerContent
            )
          }
        >
          <Comments id={id} close={() => setIsOpen(false)} />
        </Floating>
      </div>
    </CollaborationEnabledProvider>
  );
};

const EnableActionTrigger = ({
  id,
  className,
}: {
  id?: string;
  className?: string;
}) => {
  const dispatch = useAppDispatch();
  return (
    <div
      id={id}
      onClick={() => {
        dispatch(setDialogId({ id: "ZIsWK2DJpgNRaTvxRFIPZ" }));
      }}
      onKeyUp={() => {
        dispatch(setDialogId({ id: "ZIsWK2DJpgNRaTvxRFIPZ" }));
      }}
      className={cn(
        "tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-transition-opacity tw-duration-200 hover:tw-opacity-80",
        className,
      )}
    >
      <IconMessagePlus
        stroke={1.5}
        className="tw-size-4 tw-text-white !tw-fill-none"
      />
    </div>
  );
};
